import { Button, Container, Icon, Segment, Grid, Message, Header, Divider } from 'semantic-ui-react'
import './style.less'
import { useEffect, useState } from 'react'
import { newStore } from './store'
import { Relato, Props } from './type'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../stores/useStoreProfile'
import dayjs from 'dayjs'
import { EllipsisParagraph } from '../EllipsisParagraph'
import rest from '../../rest'
import { EditFormRelato } from './EdtiFormRelato'
import { Sigla } from '../Sigla'

const FormRelato = (props: Props) => {
  const [init, setInit] = useState(true)
  const [verTodos, setVerTodos] = useState(false)
  const { item } = props
  const history = useHistory()
  const { store: profile, dominios } = useStore()
  const {
    validar_reporteandamento,
    add_reporteandamento,
    change_reporteandamento,
    enviar_reporteandamento,
    concluir_revisao_reporteandamento,
    solicitar_revisao_reporteandamento,
    devolver_reporteandamento
  } = profile.permissions

  const [relatosWork, setRelatosWork] = useState<Relato[]>([])
  const [historico, setHistorico] = useState<Relato[]>([])
  const [ultimosRelatos, setUltimosRelatos] = useState<Relato[]>([])
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const getAreasRelatorasItem = (perm: { itemtrabalho: string, area_relatora: string }[]) => {
    const areas = perm.filter(e =>
      (!e.itemtrabalho || (e.itemtrabalho === item.id?.toString())) &&
      e.area_relatora
    ).map(e => +e.area_relatora)
    const distinct = new Set(areas)
    return [...distinct]
  }

  const addRelato: (number | undefined)[] = getAreasRelatorasItem(add_reporteandamento)
  const changeRelato: (number | undefined)[] = getAreasRelatorasItem(change_reporteandamento)
  const enviarRelato: (number | undefined)[] = getAreasRelatorasItem(enviar_reporteandamento)
  const concluirRevisaoRelato: (number | undefined)[] = getAreasRelatorasItem(concluir_revisao_reporteandamento)
  const solicitarRevisaoRelato: (number | undefined)[] = getAreasRelatorasItem(solicitar_revisao_reporteandamento)
  const validarRelato: (number | undefined)[] = getAreasRelatorasItem(validar_reporteandamento)
  const DevolverRelato: (number | undefined)[] = dominios.departamento.filter(e =>
    (e.departamento_pai === item.departamento) &&
    devolver_reporteandamento.find((e: any) => e.departamento === item.departamento?.toString())
  ).map(e => e.id)

  useEffect(() => {
    const situacaoTrabalho = [
      { areasRelatoras: enviarRelato, situacao: 'em_elaboracao' },
      { areasRelatoras: concluirRevisaoRelato, situacao: 'aguardando_revisao' },
      { areasRelatoras: validarRelato, situacao: 'aguardando_validacao' },
      { areasRelatoras: DevolverRelato, situacao: 'validado' }
    ]

    const getSituacaoTrabalho = (area: number) => {
      return situacaoTrabalho.filter(e => e.areasRelatoras.includes(area)).map(e => e.situacao)
    }

    const list = async () => {
      setRelatosWork([])
      try {
        const json: { results: any[] } = await rest(`reporteandamento/?itemtrabalho=${item.id}`)

        const hist = json.results.filter(e => {
          return !getSituacaoTrabalho(e.departamento).includes(e.alias_situacao) || e.resumo
        })

        const ultimos = (DevolverRelato.length ? DevolverRelato : changeRelato).map(e => {
          return hist.find(h => h.departamento === e)
        }).filter(e => e)
        setUltimosRelatos(ultimos)
        setHistorico(hist.filter(e => !ultimos.find(lr => lr.id === e.id)))

        const work: Relato[] = json.results.filter(e => !hist.map(h => h.id).includes(e.id))

        const workRelatos = (DevolverRelato.length ? DevolverRelato : changeRelato).reduce<Relato[]>((p, e) => {
          let relato = work.filter(w => w.departamento === e)

          if (!relato.length && addRelato.includes(e)) {
            const naoValidado = hist.find(h => (h.departamento === e) && h.alias_situacao !== 'validado')
            if (!naoValidado) {
              relato = [newStore(dominios.departamento.find(d => d.id === e), item.id)]
            }
          }
          if (relato.length) {
            p = p.concat(relato)
          }
          return p
        }, [])
        setRelatosWork(workRelatos)

        return json.results
      } catch (e) {
        setError(e)
      }
    }

    if (init && item.id) {
      setInit(false)
      list()
    }
  }, [init, item.id]) // eslint-disable-line

  const ShowRelato = ({ relato, basic }: { relato: Relato, basic?: boolean }) => {
    return <Segment basic={basic} clearing className='show-relato'>
      <Grid columns='equal'>
        <Grid.Row verticalAlign='middle'>
          <Grid.Column >
            Área
          </Grid.Column>
          <Grid.Column >
            Descrição
          </Grid.Column>
          <Grid.Column>
            Necessidade de apoio
          </Grid.Column>
          <Grid.Column width={1}>
            Requer atenção?
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={1} textAlign='center' verticalAlign='middle'>
            <Sigla
              size={8}
              requer_atencao={relato.requer_atencao}
            >
              {relato.sigla_departamento}
            </Sigla>
          </Grid.Column>
          <Grid.Column>
            <EllipsisParagraph
              htmlTitle={relato.sigla_departamento}
              htmlText={relato?.ultimos_andamentos || ''}
              rows={3}
            />
          </Grid.Column>
          <Grid.Column>
            <EllipsisParagraph
              htmlTitle={relato.sigla_departamento}
              htmlText={relato?.necessidade_apoio || ''}
              rows={3}
            />
          </Grid.Column>
          <Grid.Column width={1} textAlign='center' verticalAlign='middle'>
            {relato?.requer_atencao
              ? <Icon name='check square outline' />
              : <Icon name='square outline' />
            }
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Situação:&nbsp;
            {relato?.dsc_situacao}
          </Grid.Column>
          <Grid.Column>
            Data:&nbsp;
            {dayjs(relato.data_reporte).format('L')}
          </Grid.Column>
          <Grid.Column>
            Relator:&nbsp;
            {relato?.relator}
          </Grid.Column>
          {relato?.validado_em && <>
            <Grid.Column>
              Validado em:&nbsp;
              {dayjs(relato?.validado_em).format('L')}
            </Grid.Column>
            <Grid.Column>
              Validado por:&nbsp;
              {relato?.validado_por}
            </Grid.Column>
          </>}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Message
              warning
              hidden={!relato.motivo_devolucao}
              size='mini'
            >
              <Message.Content>
                <Icon name='exclamation triangle' />
                {relato.motivo_devolucao}
              </Message.Content>
            </Message>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  }

  return <Container fluid className='form-relato'>
    {error && <Message
      icon='times circle outline'
      error
      header={error}
    />}
    {success && <Message
      icon='check circle outline'
      success
      header={success}
    />}

    {relatosWork.map(relato =>
      <EditFormRelato
        key={relato.id || relato.key}
        relato={relato}
        canSave={changeRelato.includes(relato.departamento)}
        canEnviar={enviarRelato.includes(relato.departamento)}
        canValidar={validarRelato.includes(relato.departamento)}
        canSolicitarRevisao={solicitarRevisaoRelato.includes(relato.departamento)}
        canDevolver={DevolverRelato.includes(relato.departamento)}
        onSucess={(e, reload) => {
          setSuccess(e)
          if (reload) setInit(true)
        }}
        onError={e => setError(e)}
      />
    )}

    {ultimosRelatos.length
      ? <Segment.Group>
        <Segment basic>
          <Header>ÚLTIMO RELATO</Header>
        </Segment>
        {ultimosRelatos.map(relato => <ShowRelato key={relato.id} relato={relato} />)}
        <Segment basic textAlign='right' size='mini'>
          <Button
            size='mini'
            name='btn-ver-todos'
            onClick={() => setVerTodos(!verTodos)}
            disabled={!historico.length}
          >Ver todos</Button>
        </Segment>
      </Segment.Group>
      : null
    }

    {!relatosWork.length && !ultimosRelatos.length
      ? <Message compact icon='inbox' header='Não há dados' /> : null
    }

    {verTodos && historico.length && <Segment.Group>
      <Segment basic>
        <Header>Histórico</Header>
      </Segment>
      {historico.map(e => <>
        <ShowRelato basic relato={e} />
        <Divider />
      </>
      )}
    </Segment.Group>}

    <Segment basic clearing>
      <Button floated='left' name='btn-fecharrelato' onClick={() => history.goBack()}>Cancelar/Fechar</Button>
    </Segment>
  </Container>
}

export default FormRelato
